import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import config, { servicePlansEnum } from './servicePlanConfig';

import './ServicePlanHeader.scss';

const ServicePlanHeader = ({ servicePlan }) => {
  const currentPlan = config[servicePlan];

  const servicePlanHeaderCx = classNames(
    'service-plan-header',
    `service-plan-header--${servicePlan}`
  );

  return (
    <div className={servicePlanHeaderCx}>
      <div className="service-plan-header__sah">{trans('Spotahome')}</div>
      <div className="service-plan-header__name">
        {trans(currentPlan.nameKey)}
      </div>
      <div className="service-plan-header__description">
        {trans(currentPlan.descriptionKey)}
      </div>
    </div>
  );
};

ServicePlanHeader.propTypes = {
  servicePlan: PropTypes.oneOf(Object.values(servicePlansEnum)).isRequired
};

export default ServicePlanHeader;
